<template><div><h1 id="aggregierte-buchungen-liste" tabindex="-1"><a class="header-anchor" href="#aggregierte-buchungen-liste"><span>Aggregierte Buchungen, Liste</span></a></h1>
<p>Aggregierte Buchungen, Liste — Liste der Sammelbuchungen aus aggregierten Einzelbuchungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die aggregierten Buchungen werden aus den <RouteLink to="/referenz/refs/ft.refdata.einzbuch.html" title="Einzelbuchung">Einzelbuchungen</RouteLink> generiert und können nicht manuell erfasst werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Verarbeitungsläufe → Aggregierte Buchungen generieren</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Typ</dt>
<dd>
<p>Buchungstyp (siehe auch Tabelle <a class="link" href="ft.refdata.tblbuchtext.html" title="Buchungstexte">Buchungstexte</a></p>
</dd>
<dt>Belegnummer</dt>
<dd>
<p>Belegnummer</p>
</dd>
<dt>Valutadatum</dt>
<dd>
<p>Valuta Datum, entspricht dem Erfassungsdatum</p>
</dd>
<dt>Mandant</dt>
<dd>
<p>Mandant</p>
</dd>
<dt>Sollkonto</dt>
<dd>
<p>Sollkonto</p>
</dd>
<dt>Habenkonto</dt>
<dd>
<p>Habenkonto</p>
</dd>
<dt>Kostenstelle</dt>
<dd>
<p>Kostenstelle</p>
</dd>
<dt>Kostenträger</dt>
<dd>
<p>Kostenträger</p>
</dd>
<dt>Betrag LW</dt>
<dd>
<p>Betrag in Landeswährung</p>
</dd>
<dt>Betrag FW</dt>
<dd>
<p>Betrag in Fremdwährung</p>
</dd>
<dt>Kurs:</dt>
<dd>
<p>Wechselkurs der Fremdwährung</p>
</dd>
<dt>Code</dt>
<dd>
<table>
<thead>
<tr>
<th>Code</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>M</td>
<td>Kennzeichnet eine Buchung mit Mehrwertsteueranteil</td>
</tr>
<tr>
<td>leer</td>
<td>kennzeichnet alle anderen Buchungen</td>
</tr>
</tbody>
</table>
</dd>
<dt>MWST</dt>
<dd>
<p>Mehrwertsteuer-Code</p>
</dd>
<dt>S/Status:</dt>
<dd>
<p>Status der Buchung</p>
</dd>
<dd>
<p>Status 1 gilt für alle aggregierten Buchungen, keine weiteren Unterscheidungen.</p>
</dd>
<dt>Whg:</dt>
<dd>
<p>Währung</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="ab-kontoauszuge" tabindex="-1"><a class="header-anchor" href="#ab-kontoauszuge"><span>AB-Kontoauszüge</span></a></h3>
<p>Anzeigen von vordefinierten und kundenspezifischen Auswertungen. Siehe im Detail <RouteLink to="/referenz/refstat/ft.refstat.deb.html" title="Auswertungen Buchhaltung">Statistiken Debitorenverwaltung</RouteLink></p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html#Debitorenverwaltung" title="1. Debitorenverwaltung">Debitorenverwaltung</RouteLink></p>
</div></template>


